import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollController = ({ children }) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const handleHashChange = (event) => {
      const target = event.target.closest('a');
      if (target) {
        const href = target.getAttribute('href');
        if (href && href.includes('#')) {
          const hash = href.split('#')[1];
          const element = document.getElementById(hash);
          if (element) {
            const yOffset = -100; // Deslocamento de 30 pixels para cima
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
            // Remove o hash da URL após um pequeno atraso
            setTimeout(() => {
              window.history.replaceState({}, '', pathname);
            }, 100);
          }
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    };

    // Adiciona um ouvinte de eventos de clique para lidar com cliques subsequentes no mesmo link
    document.addEventListener('click', handleHashChange);

    // Executa a rolagem inicial quando o componente é montado
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        const yOffset = -100; // Deslocamento de 30 pixels para cima
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        // Remove o hash da URL após um pequeno atraso
        setTimeout(() => {
          window.history.replaceState({}, '', pathname);
        }, 100);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return () => {
      document.removeEventListener('click', handleHashChange);
    };
  }, [pathname, hash]);

  return children;
};

export default ScrollController;
